import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=64592d88&scoped=true&"
import script from "./SimpleHeader.vue?vue&type=script&lang=ts&"
export * from "./SimpleHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=64592d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64592d88",
  null
  
)

export default component.exports